import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { cacheTags } from './cacheTags';
import { CMS_API_BASE_URL } from './const';

export const cmsApi = createApi({
  reducerPath: 'cmsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: CMS_API_BASE_URL,
  }),
  endpoints: () => ({}),
  tagTypes: Object.values(cacheTags),
});
